import { render, staticRenderFns } from "./60aaae78-7e48-4de0-9a09-e575a2ac041d.vue?vue&type=template&id=232cfe2e&scoped=true"
import script from "./60aaae78-7e48-4de0-9a09-e575a2ac041d.vue?vue&type=script&lang=ts"
export * from "./60aaae78-7e48-4de0-9a09-e575a2ac041d.vue?vue&type=script&lang=ts"
import style0 from "./60aaae78-7e48-4de0-9a09-e575a2ac041d.vue?vue&type=style&index=0&id=232cfe2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232cfe2e",
  null
  
)

export default component.exports